import * as d3 from "d3";
import moment from "moment";
import tooltip from "d3-tip";
import { groupBarChartUtility } from "./groupBarChartUtility";
import {
  getChartData,
  getNoDataFoundLabel
} from "../../../utils/graph_service";
const defaultColors = [
  "#D14040",
  "#7F40D1",
  "#2D76E5",
  "#1BBC86",
  "#E2E22D",
  "#92661A",
  "#EB9563",
  "#E5897F",
  "#E24E89",
  "#C063E8",
  "#63B3E8"
];

function multiLineChartUtility(
  chartConfig,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown,
  dateFormat = undefined
) {
  RenderLineChart();

  /** render line chart */
  function RenderLineChart() {
    const drillConfigData = drillDownConfig.config.find(
      x => x.level == level + 1
    );
    if (drillDownConfig.isDrillDown && allowDrillDown == true) {
      let config = {};
      if ((chartConfig.widgetconfig || {}).isForPerformance != true) {
        let resData = {};

        const drillDownColumnsConfig = { ...chartConfig.configuration };
        const filters = [];
        if (chartConfig.configuration.isRepeated == true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [drillDownConfig.config.find(x => x.level == level + 1).key]
          });
          drillDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          drillDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              x =>
                x.name ==
                drillDownConfig.config.find(x => x.level == level + 1).key
            )
          ];
        }

        resData = getChartData(
          chartConfig.rawData,
          drillDownColumnsConfig,
          drillConfigData.seriesItem.start,
          drillConfigData.seriesItem.end,
          drillConfigData.type
        );

        config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: drillDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: chartConfig.yAxisLabel,
          type: "GroupBarChart",
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level,
          allowDrillDown
        );
      } else {
        config = drillConfigData.performanceConfig;

        generateLineChart(
          config.data,
          config.multiLineChartAccessors,
          config.colors,
          divId,
          config.yAxisLabel
        );
      }
      if (drillDownConfig.currentLevel == level + 1) {
        drillDownConfig.isDrillDown = false;
      }
    } else {
      generateLineChart(
        chartConfig.data,
        chartConfig.multiLineChartAccessors,
        chartConfig.colors,
        divId,
        chartConfig.yAxisLabel
      );
    }
  }

  /** create line chart based on parameters or information recieved by apis */
  function generateLineChart(data, accessors, colors, divId, yAxisLabel, type) {
    const node = document.getElementById(divId);

    if (!data || !node) return;

    if (node !== null) {
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    }

    // set the dimensions and margins of the graph
    // var margin = { top: 40, right: 20, bottom: 30, left: 20 };
    const margin = { top: 20, right: 20, bottom: 30, left: 40 };
    let width = 400 - margin.left;
    let height = 300 - margin.top - margin.bottom;
    if (node.offsetWidth > width) {
      width = node.offsetWidth - margin.left;
      height = node.offsetHeight > height ? node.offsetHeight - 140 : height;
    }

    const svg = d3
      .select("#" + divId)
      .append("svg")
      .attr("viewBox", [
        0,
        0,
        width + margin.right,
        height + margin.top + margin.right + margin.bottom + 40
      ])
      //.attr('viewBox','0 0 '+Math.min(width,height) +' '+Math.min(width,height) )
      .attr("preserveAspectRatio", "xMinYMin")
      .append("g")
      .attr(
        "transform",
        "translate(" + (margin.top + margin.left) + "," + margin.right + ")"
      );
    const x = d3.scalePoint().range([20, width - 90]);
    const y = d3.scaleLinear().range([height, 20]);

    // Scale the range of the data
    x.domain(
      data.map(function(d) {
        return d[accessors.mainAccessor];
      })
    );

    y.domain([
      0,
      d3.max(data, function(d) {
        let maxValue = -1;

        Object.keys(accessors).forEach(function(key) {
          let max = 0;
          if (key !== "mainAccessor") {
            if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
              max = Math.max(parseFloat(d[accessors[key]]).toFixed(2));
            } else {
              max = Math.max(parseFloat(d[accessors[key]]));
            }
            if (max > maxValue) {
              maxValue = max;
            }
          }
        });
        return maxValue;
      })
    ]);
    //.curve(d3.curveBasis)
    document.querySelectorAll(".tooltip" + divId).forEach(function(a) {
      a.remove();
    });
    const tip = tooltip()
      .attr("class", "d3-tip tooltip" + divId)
      .html(function(d) {
        return d;
      });
    svg.call(tip);

    const keys = [];
    const valueLines = [];
    Object.keys(accessors).forEach(function(key) {
      if (key !== "mainAccessor") {
        const valueLineData = d3
          .line()
          // .interpolate("cardinal")
          .curve(d3.curveMonotoneX)
          .x(function(d) {
            return x(d[accessors["mainAccessor"]]);
          })
          .y(function(d) {
            return y(d[accessors[key]]);
          });
        valueLines.push({ dataValueLine: valueLineData, dataKey: key });
        keys.push(key);
      }
    });
    // Added horizontal line for identification
    svg
      .append("g")
      .attr("class", "grid")
      .style("color", "#a3a3a3")
      .style("z-index", "999")
      .call(
        d3
          .axisLeft(y)
          .tickSize(-width)
          .tickFormat("")
      );

    // Add the X Axis
    svg
      .append("g")
      .attr("class", "x-axis")
      .style("color", "#000000")
      .style("font-family", "roboto")
      .style("font-weight", "500")
      .style("font-size", "10px")
      .attr("transform", "translate(0," + height + ")")
      .call(
        d3
          .axisBottom(x)
          .tickPadding(5)
          .tickSize(5)
          .tickFormat(function(d) {
            if (dateFormat != undefined) {
              return moment(d).format(dateFormat);
            }
            return d;
          })
      )
      .selectAll(".tick text")
      //.call(x.bandwidth())
      .attr("transform", "rotate( -45)")
      .html("")
      .append("tspan")
      .text(function(d) {
        return d;
      })

      .attr("y", -2)
      .attr("x", -10)
      .style("text-anchor", "end")
      .call(g => g.select(".domain").style("color", "#252525"));

    // Add the Y Axis
    svg
      .append("g")
      .attr("class", "y-axis")
      .style("color", "#000000")
      .style("font-family", "roboto")
      .style("font-weight", "500")
      .style("font-size", "10px")
      .call(
        d3
          .axisLeft(y)
          .tickFormat(function(d) {
            return d;
          })
          .ticks(10)
          .tickPadding(5)
          .tickSize(5)
      )
      .call(g => g.select(".domain").style("color", "#252525"))
      .selectAll("text")
      .attr("x", "-5");
    let totalCount = 0;
    data.forEach(function(d) {
      if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
        d.total = d3.sum(keys, k => +parseFloat(d[accessors[k]]).toFixed(2));
      } else {
        d.total = d3.sum(keys, k => +parseFloat(d[accessors[k]]));
      }
      totalCount += d.total;
      return d;
    });

    if (totalCount == 0) {
      getNoDataFoundLabel(
        moment(chartConfig.startDate).format("MM/DD/YYYY") +
          " to " +
          moment(chartConfig.endDate).format("MM/DD/YYYY"),
        svg,
        height / 2,
        width / 2
      );
    } else {
      valueLines.map(lineItem => {
        const color =
          colors[accessors[lineItem.dataKey]] ||
          (defaultColors[lineItem] || defaultColors[0]);
        svg
          .append("path")
          .attr("clip-path", "url(#clip)")
          .data([data])
          .style("fill", "none")
          .style("stroke", color)
          .style("cursor", "pointer")
          .style("stroke-width", "1.5px")
          .style("z-index", "9999")
          .attr("class", "line")
          .attr("d", lineItem.dataValueLine)
          .on("mouseover", function() {
            svg
              .append("text")
              .attr("class", "title-text")
              .style("fill", color)
              .text(accessors[lineItem.dataKey])
              .attr("text-anchor", "middle")
              .attr("x", width / 2)
              .attr("y", 0);
            d3.selectAll(".line")
              .transition()
              .duration(200)
              .style("opacity", 0.5);
            d3.select(this)
              .transition()
              .duration(200)
              .style("opacity", 1)
              .style("stroke-width", "2.5px");
          })
          .on("mouseout", function() {
            //tip.hide();
            svg.select(".title-text").remove();
            d3.selectAll(".line")
              .transition()
              .duration(200)
              .style("opacity", 1)
              .style("stroke-width", "1.5px");
          });

        svg
          .selectAll("line-circle")
          .data(data)
          .enter()
          .append("circle")
          .style("z-index", "999999")
          .attr("r", 5.5)
          .style("fill", color)
          .style("stroke", color)
          //.style("pointer-events", "all")
          .style("cursor", "pointer")
          .style("z-index", "999999")
          .attr("cx", function(d) {
            return x(d[accessors.mainAccessor]);
          })
          .attr("cy", function(d) {
            return y(d[accessors[lineItem.dataKey]]);
          })
          .attr("class", "line-circle")
          .on("click", function() {})
          .on("mouseover", function(d) {
            tip.show(
              accessors[lineItem.dataKey] +
                ": " +
                ((chartConfig.widgetconfig || {}).isForPerformance == true
                  ? parseFloat(d[accessors[lineItem.dataKey]])
                      .toFixed(2)
                      .toLocaleString()
                  : parseFloat(d[accessors[lineItem.dataKey]])
                ).toLocaleString() +
                " " +
                ((chartConfig.unit || "") == null
                  ? ""
                  : chartConfig.unit || ""),
              this
            );

            svg
              .append("text")
              .attr("class", "title-text")
              .style("fill", color)
              .text(
                accessors[lineItem.dataKey] +
                  ": " +
                  d[accessors[lineItem.dataKey]] +
                  " " +
                  ((chartConfig.unit || "") == null
                    ? ""
                    : chartConfig.unit || "")
              )
              .attr("text-anchor", "middle")
              .attr("x", width / 2)
              .attr("y", 0);
            d3.selectAll(".line-circle")
              .transition()
              .duration(200)
              .style("opacity", 0.5);
            d3.select(this)
              .transition()
              .duration(200)
              .style("opacity", 1)
              .style("stroke-width", "2.5px");
          })
          .on("mouseout", function() {
            tip.hide();
            svg.select(".title-text").remove();
            d3.selectAll(".line-circle")
              .transition()
              .duration(200)
              .style("opacity", 1)
              .style("stroke-width", "1.5px");
          })
          .on("click", function(d) {
            //alert(d.key + d[groupKey]);
            tip.hide();
            type = "Month";
            if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
              level = drillDownConfig.currentLevel;
              type = accessors.mainAccessor == "YTD" ? "Month" : "Day";
            }
            if (allowDrillDown == true) {
              onDrillDown(
                true,
                accessors[lineItem.dataKey],
                type,
                d[accessors.mainAccessor],
                level + 1,
                d.seriesItem
              );
            }
          });
      });
    }
    if (drillDownConfig.currentLevel > 1) {
      let type = "Month";
      if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
        level = drillDownConfig.currentLevel;
        type = "YTD";
        allowDrillDown = true;
      }
      svg
        .append("svg")
        .style("fill", "#07406d")
        .style("cursor", "pointer")
        .attr("y", -10)
        .attr("x", -10)
        .append("path")
        .attr(
          "d",
          "M22 3H7c-.69 0-1.23.35-1.59.88L.37 11.45c-.22.34-.22.77 0 1.11l5.04 7.56c.36.52.9.88 1.59.88h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.7 13.3c-.39.39-1.02.39-1.41 0L14 13.41l-2.89 2.89c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L12.59 12 9.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L14 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L15.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
        )
        .on("click", function() {
          //alert("jj");
          onDrillDown(false, drillDownConfig.key, type, "", level);
        });
    }
    svg
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", -(margin.left + +10))
      .attr("x", 0 - height / 2)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .style("font-family", "Roboto")
      .style("font-size", "10px")
      .style("font-weight", "500")
      .style("fill", "#000000")
      .text(yAxisLabel || "count");

    let legendLine = 10;
    let currentX = 0;
    const legend = svg
      .append("g")
      .attr("class", "legend-container")
      .attr("height", 100)
      .attr("width", width)
      .attr("class", "bottom-row")
      .attr(
        "transform",
        "translate(" + 0 + ", " + (height + margin.bottom + margin.top) + ")"
      );
    legend
      .selectAll("g")
      .data(keys)
      .enter()
      .append("g")
      .each(function(d, i) {
        const g = d3.select(this);
        let y = legendLine;
        const rect = g
          .append("rect")
          .attr("y", y)
          .attr("x", currentX)
          .attr("width", 10)
          .attr("height", 10)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style(
            "fill",
            colors[accessors[d]] || (defaultColors[i] || defaultColors[0])
          );
        const size = rect.node().getBBox();
        currentX += size.width + 10;
        if (currentX > width) {
          currentX = 0;
          legendLine += 30;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
        }
        const recText = g
          .append("text")
          .attr("y", y + 10)
          .attr("x", currentX)
          .attr("height", 30)
          .attr("width", 170)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style(
            "fill",
            colors[accessors[d]] || (defaultColors[i] || defaultColors[0])
          )
          .style("font-family", "roboto")
          .style("font-weight", "500")
          .style("font-size", "12px")
          .text(accessors[d]);

        const recTextSize = recText.node().getBBox();
        currentX += recTextSize.width + 20;
        if (currentX > width) {
          currentX = 0;
          legendLine += 30;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
          recText.attr("x", currentX).attr("y", y + 10);
          currentX += recTextSize.width + 20;
        }
      });
  }
}
export { multiLineChartUtility };
